<template>
  <div class="top_icon">
    <a :href="icon.url" :target="icon.target">
      <img :src="icon.image">
      <!-- <span>{{ icon.text }}</span> -->
    </a>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.top_icon {
  a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    img {
      width: 60px;
    }
    span {
      margin-top: 5px;
      font-size: 12px;
      color: $white;
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .top_icon {
    a {
      img {
        width: 40px;
      }
      span {
        font-size: 10px;
      }
    }
  }
}
</style>
